import { z } from 'zod';

export const AiPurpose = z.enum([
  'task_parse',
  'translate',
  'ocr',
  'classify_priority',
  'classify_receipt_category',
  'suggestion',
  'voice_transcribe',
  'chain_planner',
]);
export type AiPurpose = z.infer<typeof AiPurpose>;

export const AiCallLog = z.object({
  purpose: AiPurpose,
  model: z.string(),
  prompt_tokens: z.number().int().nonnegative().nullable(),
  completion_tokens: z.number().int().nonnegative().nullable(),
  total_tokens: z.number().int().nonnegative().nullable(),
  latency_ms: z.number().int().nonnegative().nullable(),
  cost_usd_micros: z.number().int().nonnegative().nullable(),
  ok: z.boolean(),
  error_code: z.string().nullable(),
});
export type AiCallLog = z.infer<typeof AiCallLog>;
